"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@dynamynd/core");

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

exports.FooterContainer = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: fixed;\n    z-index: 2;\n    max-height: 50px;\n    ", "\n"], ["\n    position: fixed;\n    z-index: 2;\n    max-height: 50px;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  var small = responsive_1.isSmall(activeBreakpoint);
  var gutter = small ? core_1.GutterSizeEnum.small : core_1.GutterSizeEnum.wide;
  return "\n            bottom: " + gutter + "px;\n            left: " + gutter + "px;\n            right: " + gutter + "px;\n        ";
});
exports.FooterWrapper = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-grow: 0;\n    flex-flow: row nowrap;\n    justify-content: space-between;\n    align-items: center;\n"], ["\n    display: flex;\n    flex-grow: 0;\n    flex-flow: row nowrap;\n    justify-content: space-between;\n    align-items: center;\n"])));
exports.LinksContainer = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex: 0 1 290px;\n    max-width: 290px;\n    max-height: 32px;\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: space-between;\n    align-items: center;\n"], ["\n    flex: 0 1 290px;\n    max-width: 290px;\n    max-height: 32px;\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: space-between;\n    align-items: center;\n"])));
exports.AllRightsReservedLabel = styled_components_1.default(function (_a) {
  var color = _a.color,
      rest = __rest(_a, ["color"]);

  return react_1.default.createElement(react_native_1.Text, __assign({}, rest));
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
  var theme = _a.theme,
      color = _a.color;
  return "\n            font-size: " + theme.typography.link.fontSize + "px;\n            line-height: " + theme.typography.link.lineHeight + "px;\n            color: " + color + ";\n        ";
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;